module.exports = __webpack_public_path__ + "img/tb-4.e41063d7.webp";